import Ajax from '@/lib/ajax'
import Util from '@/lib/util'

export default {
  // 创建分组
  createProductOutfit(name: string) {
    return Ajax.post(`/api/MarketingManagement/OutfitGroup/CreateProductOutfitA?name=${name}`)
  },
  // 查询所有分组名
  getAllgroupList() {
    return Ajax.get(`/api/MarketingManagement/OutfitGroup/ListOutfit`)
  },
  // 查询分页分组名
  getAllOutfitList(currentPage: number, pageSize: number, name: string) {
    let params = {
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
      name
    }
    return Ajax.get(`/api/MarketingManagement/OutfitGroup/PageOutfit`, {
      params
    })
  },
  // 删除分组
  deleteOutfit(ids: any[]) {
    let id = '?id=' + ids.join('&')
    return Ajax.delete(`/api/MarketingManagement/OutfitGroup/Del` + id)
  },
  // 修改分组名
  updateOutfit(id: string, name: string) {
    return Ajax.put(`/api/MarketingManagement/OutfitGroup/${id}?name=${name}`)
  }
}